import { Plus } from "lucide-react";

export default function ProductCard({ product, onQuickView, index = 0 }) {
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group cursor-pointer"
      onClick={() => onQuickView(product)}
    >
      <div className="relative aspect-[4/5] overflow-hidden border border-white/5 bg-coal">
        <img
          src={`${product.image}&w=900&auto=format`}
          alt={product.name}
          loading={index > 2 ? "lazy" : "eager"}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {product.tag && (
          <span className="absolute left-4 top-4 border border-ember/60 bg-ink/70 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.3em] text-ember backdrop-blur-md">
            {product.tag}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 translate-y-full transition-transform duration-500 ease-out group-hover:translate-y-0">
          <div className="flex items-center justify-center gap-2 bg-ink/80 py-4 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-100 backdrop-blur-md">
            <Plus className="h-3.5 w-3.5 text-ember" /> Quick view
          </div>
        </div>
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-base font-semibold uppercase leading-tight tracking-wide">
            {product.name}
          </h3>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
            {product.category}
          </p>
        </div>
        <p className="shrink-0 font-mono text-sm text-zinc-300">€{product.price.toFixed(0)}</p>
      </div>
    </div>
  );
}
